import About from "../components/pages/About/About.js";

//Everything inside the routes is how Router library works
export default function AboutLink() {
  return <About />;
}
